import { Col, Container, Row } from "react-grid-system";
import { Sidemenu } from "../../components/Sidemenu";
import { STabs, STabList, STab, STabPanel } from "../../styles/Tabs";
import { StyledPageHeader } from "../../styles/StyledPage";
import CalendarIcon from "../../assets/img/icons/calendar.svg";
import moment from "moment";
import { AdminTable } from "../../components/AdminTable";
import { addCategory, getCategoriesList, editCategory, deleteCategory } from "../../api/admin/categories";
import { addLabel, getLabelsList, editLabel, deleteLabel } from "../../api/admin/labels";
import { AdminSearchScore } from "../../components/AdminSearchScore";
import { SearchMappingAdmin } from "../../components/Admin/SearchMappingAdmin";
import { Users } from "../../components/Users";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getUser } from "../../api/admin/user";
import { useEffect, useState } from "react";

export default function AdminPage() {
	const { axiosPrivate } = useAxiosPrivate();
	const [currentRole, setCurrentRole] = useState(null);
	useEffect(() => {
		const fetchUser = async () => {
			try {
				const profileRes = await axiosPrivate.get("/user/profile.json");
				const userId = profileRes.data.id;
				const user = await getUser(axiosPrivate, userId);
				const roles = user.roles;
				if (roles.includes("ROLE_ROOT")) {
					setCurrentRole("root");
				} else if (roles.includes("ROLE_ADMIN")) {
					setCurrentRole("admin");
				} else {
					setCurrentRole(null);
				}
			} catch (err) {
				console.error("Failed to fetch current user", err);
			}
		};
		fetchUser();
		}, []);


	return (
		<Container>
			<Row style={{ marginTop: "2rem" }}>
				<Col sm={12} lg={2}>
					<Sidemenu />
				</Col>
				<Col sm={12} lg={10}>
					<StyledPageHeader>
						<h1>Admin Panel</h1>
						<div>
							<i>
								<img src={CalendarIcon} alt="Date" />
							</i>
							<span>{`${moment(new Date()).format("YYYY-MM-DD")}`}</span>
						</div>
					</StyledPageHeader>
					<STabs selectedTabClassName="is-selected" selectedTabPanelClassName="is-selected">
						<STabList>
							<STab>Categories</STab>
							<STab>Labels</STab>
							{currentRole === "root" && <STab>Search mapping</STab>}
							{currentRole === "root" && <STab>Decision mapping</STab>}
							{currentRole === "root" && <STab>User mapping</STab>}
							<STab>Users</STab>
						</STabList>
						<STabPanel>
							<AdminTable name={"Categories"} getFunc={(axios) => getCategoriesList(axios, currentRole !== "root")} addFunc={addCategory} editFunc={editCategory} deleteFunc={deleteCategory} />
						</STabPanel>
						<STabPanel>
							<AdminTable name={"Labels"} getFunc={(axios) => getLabelsList(axios, currentRole !== "root")} addFunc={addLabel} editFunc={editLabel} deleteFunc={deleteLabel} />
						</STabPanel>
						{currentRole === "root" && (
						<STabPanel>
							<SearchMappingAdmin />
						</STabPanel>
						)}
						{currentRole === "root" && (
						<STabPanel>
							<AdminSearchScore group="decision" />
						</STabPanel>
						)}
						{currentRole === "root" && (
						<STabPanel>
							<AdminSearchScore group="user" />
						</STabPanel>
						)}
						<STabPanel>
							<Users />
						</STabPanel>
					</STabs>
				</Col>
			</Row>
		</Container>
	);
}
